"use client";
import React, { Fragment } from "react";
import Link from "next/link";
import { IconButton, Flex, Text } from "@chakra-ui/react";
import { IoArrowForward } from "@onemind-services-llc/react-icons-ng/io5";
import { useDashboardLoginURL } from "@/hooks/useDashboardLoginURL";

type Props = {
  inStock?: boolean;
  plan?: string;
  product?: string;
  selectedFrequency?: string;
  selectedOS?: string;
};

const RenderBuyNow = (props: Props) => {
  const { inStock = true, plan, product = "", selectedFrequency, selectedOS } = props;
  let dashboardLoginURL = useDashboardLoginURL();
  if (product || plan || selectedFrequency || selectedOS) {
    dashboardLoginURL = `${dashboardLoginURL}?next=${encodeURIComponent(`/app/add-product/${product}?os=${selectedOS}&plan=${plan}&frequency=${selectedFrequency}`)}`;
  }

  return (
    <Fragment>
      {inStock ? (
        <Link href={dashboardLoginURL}>
          <Flex
            align="center"
            bg="brand.100"
            color="white"
            width={"fit-content"}
            borderRadius={"4px"}
          >
            <Text ml={2}>Buy </Text>
            <IconButton
              aria-label="Buy Now"
              title="Buy Now"
              bg="brand.100"
              color="white"
              icon={<IoArrowForward />}
              size="sm"
              _hover={{ backgroundColor: "brand.100", color: "white" }}
            />
          </Flex>
        </Link>
      ) : (
        <Text>Out Of Stock</Text>
      )}
    </Fragment>
  );
};

export default RenderBuyNow;
